// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TintIconSignature {
  Element: SVGSVGElement;
}

export const TintIcon: TOC<TintIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 15C5 18.86 8.14 22 12 22C15.86 22 19 18.86 19 15C19 11.557 13.916 4.01401 12 1.24001C10.094 4.00001 5 11.554 5 15ZM7 15C7 13.066 9.796 8.15701 12 4.79301C14.204 8.15601 17 13.066 17 15C17 17.757 14.757 20 12 20C9.243 20 7 17.757 7 15Z"/>
</svg>
</template>;